import { Anchor, Container, Text } from '@mantine/core';
import classes from './BaseLayout.module.css';
import { env } from '../utils/env';
import { Link } from 'react-router-dom';
import { EmailSignupCard } from '../components/common/EmailSignupCard';

function Footer() {
  return (
    <footer className={classes.footer}>
      <Container size="lg" className={classes.footerContent}>
        <Container size="fluid" style={{ margin: '0 auto', marginBottom: 10 }}>
          <EmailSignupCard />
        </Container>
        <div className={classes.footerLinks}>
          <Anchor component={Link} to="/contact">
            <Text size="sm" component="span">
              Contact Us
            </Text>
          </Anchor>
          <Anchor component={Link} to="/terms">
            <Text size="sm" component="span">
              Terms of Service
            </Text>
          </Anchor>
          <Anchor component={Link} to="/privacy">
            <Text size="sm" component="span">
              Privacy Policy
            </Text>
          </Anchor>
          <Anchor component={Link} to="/about-us">
            <Text size="sm" component="span">
              About Us
            </Text>
          </Anchor>
          <Anchor component={Link} to="/draw">
            <Text size="sm" component="span">
              Draw Info
            </Text>
          </Anchor>
        </div>
        {env.APP_TAG_LINE && (
          <Text size="sm" ta="center">
            {env.APP_TAG_LINE}
          </Text>
        )}
        <Text size="sm" ta="center">
          © {new Date().getFullYear()} {env.APP_NAME}. All rights reserved.
        </Text>
      </Container>
    </footer>
  );
}

export default Footer;
